import { map, range } from "lodash";

/**
 * Zero-pads number to specified length.
 * 
 * @param num Number
 * @param length Min number of characters in returned string
 * @returns Zero-padded numeric string
 */
export function zeroPadNumber(num: number, length: number = 2): string {
	if (length < 2) {
		return num.toString();
	}
	const numDigits: number = Math.floor(num).toString().length;
	const numZeroes: number = length - numDigits;
	if (numZeroes <= 0) {
		return num.toString();
	}
	return map(range(0, numZeroes), () => "0").join("") + num.toString();
}

/**
 * Attempts to JSON-decode json string, returning undefined on error.
 */
export function safeParseJSON(json: string): any {
	try {
		return JSON.parse(json);
	}
	catch (e) {
		console.error("Failed to parse JSON string", json, e);
		return undefined;
	}
}
